import { render, staticRenderFns } from "./tariff.vue?vue&type=template&id=2dded3c6&"
import script from "./tariff.vue?vue&type=script&lang=js&"
export * from "./tariff.vue?vue&type=script&lang=js&"
import style0 from "./tariff.vue?vue&type=style&index=0&id=2dded3c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports